import Flex from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'
import PyroForm from 'pyro-form'
import React from 'react'

import { throttledPyroFormValidator } from '@eversports/react-components/utilities/pyro-form-validate'
import { Localized } from '../../../localization/react'
import { RequiredInformationInitialValues, RequiredInformationType } from '../../../typings/AdditionalInformation'

import RequiredInformationTypeMapper from './RequiredInformationTypeMapper'

interface Props {
  venueName: string
  initialValues: RequiredInformationInitialValues
  requiredInformationTypes: Array<RequiredInformationType>
  handleValidate: (values: RequiredInformationInitialValues) => Record<string, unknown>
}

const RequiredInformationComponent: React.FC<React.PropsWithChildren<Props>> = ({
  venueName,
  initialValues,
  requiredInformationTypes,
  handleValidate,
}) => (
  <Flex flexDirection="column" verticalSpacing="default" data-testid="required-information-container">
    <Text color="subtleText" fontWeight="bold" textTransform="uppercase">
      <Localized id="additional-info-subtitle" />
    </Text>
    <Text marginBottom="wide">
      <Localized id="additional-info-desc" params={{ venueName }} />
    </Text>
    <PyroForm initialValues={initialValues} onValidate={throttledPyroFormValidator(handleValidate)}>
      <Flex flexDirection="column" verticalSpacing="default" marginBottom="hero">
        {requiredInformationTypes.map((requiredInformationType, index) => (
          <RequiredInformationTypeMapper key={index} requiredInformationType={requiredInformationType} />
        ))}
      </Flex>
    </PyroForm>
  </Flex>
)

export default RequiredInformationComponent
